import { useRecoilState } from 'recoil';
import projectAtom from 'ProjectManager/Project/Common/recoil/project/projectAtom';
import { useCallback, useEffect, useMemo } from 'react';
import axios from 'axios';
import addProjectCustomTopic from 'ProjectManager/Project/Common/api/dataManagement/customTopic/addProjectCustomTopic';
import getProjectQuestionnaireSections from 'ProjectManager/Project/Common/api/dataManagement/questionnaire/getProjectQuestionnaireSections';
import withCustomTopic from 'ProjectManager/DataManagement/Common/recoil/projectOrTemplate/modifiers/customTopic/withCustomTopic';
import withQuestionnaireSections from 'ProjectManager/DataManagement/Common/recoil/projectOrTemplate/modifiers/questionnaire/withQuestionnaireSections';

const useCreateProjectCustomTopicFunction = () => {
    const [{ id: projectId }, setProject] = useRecoilState(projectAtom);

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    // noinspection UnnecessaryLocalVariableJS
    const createCustomTopic = useCallback(
        async values => {
            const response = await addProjectCustomTopic(
                projectId,
                values,
                source.token,
            );

            const questionnaireSections = await getProjectQuestionnaireSections(
                projectId,
                source.token,
            );

            const newCustomTopic = response.data;

            setProject(withCustomTopic(newCustomTopic));
            setProject(withQuestionnaireSections(questionnaireSections));
        },
        [projectId, setProject, source.token],
    );

    return createCustomTopic;
};

export default useCreateProjectCustomTopicFunction;
